/*
 * "Load more" for the native collection / search grids (sections/main-collection-product-grid.liquid,
 * sections/main-search.liquid). Filtering & sorting are handled by assets/facets.js.
 * The button is a real link to the next page, so it still works without JavaScript.
 */
(function () {
  if (window.agDiscoveryInit) return;
  window.agDiscoveryInit = true;

  // Links rendered through the Section Rendering API (facets.js / load more) can carry section_id
  function cleanUrl(href) {
    var url = new URL(href, window.location.origin);
    url.searchParams.delete('section_id');
    return url;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ag-load-more]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('loading')) return;

    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');

    var pageUrl = cleanUrl(button.href).toString();
    var url = cleanUrl(button.href);
    url.searchParams.set('section_id', button.dataset.sectionId);

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var grid = document.getElementById('product-grid');
        var wrapper = button.closest('[data-ag-load-more-wrapper]');

        html.querySelectorAll('#product-grid > .grid__item').forEach(function (item) {
          grid.appendChild(document.importNode(item, true));
        });

        var nextWrapper = html.querySelector('[data-ag-load-more-wrapper]');
        if (nextWrapper) {
          var nextNode = document.importNode(nextWrapper, true);
          var nextLink = nextNode.querySelector('[data-ag-load-more]');
          if (nextLink) nextLink.href = cleanUrl(nextLink.getAttribute('href')).toString();
          wrapper.replaceWith(nextNode);
        } else {
          wrapper.remove();
        }
      })
      .catch(function () {
        window.location.href = pageUrl;
      });
  });
})();
